import React from "react";
import { CloudOff, FileClock, Trash2 } from "lucide-react";
import { Pill } from "./UI";

export const NoteDrafts = ({ drafts, clients, onLoad, onDelete }) => {
  if (!drafts.length) return null;
  const name = (id) => {
    const c = clients.find((x) => x.id === id);
    return c ? `${c.first_name} ${c.last_name}` : "No client selected";
  };
  return (
    <div className="mt-6 pt-5 border-t" style={{ borderColor: "var(--mf-muted)" }} data-testid="note-drafts">
      <div className="flex items-center gap-2 mb-3">
        <FileClock className="w-5 h-5" style={{ color: "var(--mf-accent)" }} />
        <h3 className="font-serif text-xl">Drafts</h3>
        <span className="text-xs" style={{ color: "var(--mf-text-muted)" }}>{drafts.length}</span>
      </div>
      <div className="space-y-2">
        {drafts.map((d) => (
          <div key={d.local_id} className="p-3 rounded-xl flex items-center gap-3" style={{ background: "var(--mf-muted)" }} data-testid={`draft-${d.local_id}`}>
            <button className="flex-1 text-left min-w-0" onClick={() => onLoad(d)} data-testid={`draft-load-${d.local_id}`}>
              <div className="flex items-center gap-2 mb-0.5 flex-wrap">
                <span className="text-sm font-medium">{name(d.client_id)}</span>
                <Pill>{d.format}</Pill>
                {d.pending && <Pill variant="warn"><span className="inline-flex items-center gap-1"><CloudOff className="w-3 h-3" /> Pending sync</span></Pill>}
              </div>
              <div className="text-xs truncate" style={{ color: "var(--mf-text-muted)" }}>{d.session_summary}</div>
            </button>
            <button onClick={() => onDelete(d)} className="p-2 rounded-lg hover:bg-black/5" aria-label="Delete draft" data-testid={`draft-delete-${d.local_id}`}>
              <Trash2 className="w-4 h-4" style={{ color: "var(--mf-text-muted)" }} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
